import { KeyboardArrowDown } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { useMemo } from 'react';

export function EventSensor({
  sensorClass,
  parameters
}: {
  sensorClass: string;
  parameters: Array<string>;
}) {
  return (
    <Accordion
      sx={{
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
        borderRadius: '4px',
        boxShadow: `0 0 #000000`,
        border: `1px solid #000000`,
        marginBottom: 0
      }}
    >
      <AccordionSummary
        sx={{ paddingTop: '0px', paddingBottom: '0px', marginBottom: '0px' }}
        expandIcon={<KeyboardArrowDown />}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            maxWidth: '100%',
            gap: 8,
            alignItems: 'center',
            justifyContent: 'start'
          }}
        >
          <span style={{ fontWeight: 'bold' }}>Sensor:</span>
          <span style={{}}>{sensorClass}</span>
        </div>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          display: `flex`,
          flexDirection: `column`,
          gap: '4px'
        }}
      >
        <span
          style={{
            fontWeight: 'bold'
          }}
        >
          Parameters:
        </span>
        <div
          style={{
            display: `flex`,
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '8px'
          }}
        >
          {parameters.map((param) => (
            <div
              key={param}
              style={{
                padding: '8px',
                borderRadius: '8px',
                border: '1px dashed',
                display: `flex`,
                gap: '4px'
              }}
            >
              <div
                style={{
                  display: `flex`,
                  flexDirection: `row`,
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '4px'
                }}
              >
                <span>{param}</span>
              </div>
            </div>
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
}
